var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1Upcoming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#A0576E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7636 14.9871C58.7627 15.0392 58.746 15.0898 58.7155 15.1321C58.6851 15.1743 58.6424 15.2063 58.5933 15.2237L58.2148 15.3656C56.603 16.0277 55.2244 17.1539 54.254 18.6011C53.2835 20.0483 52.7651 21.7513 52.7645 23.4938V48.2189C52.7657 49.3724 52.5395 50.5148 52.0986 51.5808C51.6578 52.6467 51.011 53.6152 50.1953 54.4309C49.3797 55.2465 48.4112 55.8933 47.3453 56.3341C46.2793 56.775 45.1369 57.0012 43.9834 57H15.5017C15.4666 57.0013 15.4315 56.9954 15.3988 56.9825C15.366 56.9697 15.3363 56.9502 15.3114 56.9254C15.2865 56.9005 15.2671 56.8707 15.2542 56.838C15.2414 56.8052 15.2354 56.7702 15.2368 56.7351C15.2369 56.679 15.2555 56.6245 15.2897 56.58C15.3239 56.5355 15.3718 56.5036 15.426 56.489L15.8045 56.3376C17.412 55.6743 18.7863 54.5486 19.7533 53.1032C20.7202 51.6578 21.2362 49.9579 21.2359 48.2189V23.5032C21.2431 21.5244 21.9191 19.6062 23.1543 18.0601C24.3894 16.5141 26.111 15.4311 28.0393 14.9871C28.6874 14.8344 29.3511 14.7581 30.017 14.76H58.4987C58.5634 14.7572 58.6268 14.7791 58.676 14.8213C58.7252 14.8634 58.7565 14.9227 58.7636 14.9871Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8084 23.0208H25.2385V30.5906H32.8084V23.0208Z",
    fill: "#EEC98A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8084 37.3752H25.2385V44.9451H32.8084V37.3752Z",
    fill: "#EEC98A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4896 30H28.4365C28.287 29.9925 28.1407 29.9517 28.0072 29.8802C27.8737 29.8088 27.756 29.7083 27.6619 29.5855L25.232 26.3814C25.0561 26.1481 24.9752 25.8506 25.007 25.5544C25.0389 25.2582 25.1809 24.9874 25.4018 24.8017C25.6227 24.616 25.9044 24.5305 26.185 24.5642C26.4656 24.5978 26.722 24.7477 26.8979 24.9809L28.5745 27.2216L33.1902 22.3258C33.389 22.1171 33.658 22 33.9383 22C34.2186 22 34.4876 22.1171 34.6864 22.3258C34.7858 22.4299 34.8648 22.5538 34.9186 22.6904C34.9725 22.8269 35.0002 22.9733 35.0002 23.1212C35.0002 23.2691 34.9725 23.4155 34.9186 23.5521C34.8648 23.6886 34.7858 23.8125 34.6864 23.9166L29.2323 29.6751C29.0347 29.8821 28.7679 29.9988 28.4896 30Z",
    fill: "#302322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4896 43.9998H28.4365C28.287 43.9922 28.1407 43.9514 28.0072 43.88C27.8737 43.8085 27.756 43.7081 27.6619 43.5852L25.232 40.3811C25.0561 40.1479 24.9752 39.8504 25.007 39.5542C25.0389 39.2579 25.1809 38.9872 25.4018 38.8015C25.6227 38.6157 25.9044 38.5303 26.185 38.5639C26.4656 38.5975 26.722 38.7475 26.8979 38.9807L28.5745 41.2214L33.1902 36.3255C33.389 36.1169 33.658 35.9998 33.9383 35.9998C34.2186 35.9998 34.4876 36.1169 34.6864 36.3255C34.7858 36.4297 34.8648 36.5536 34.9186 36.6901C34.9725 36.8266 35.0002 36.9731 35.0002 37.121C35.0002 37.2689 34.9725 37.4153 34.9186 37.5518C34.8648 37.6883 34.7858 37.8122 34.6864 37.9164L29.2323 43.6749C29.0347 43.8818 28.7679 43.9985 28.4896 43.9998Z",
    fill: "#302322"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 12,
    height: 2,
    rx: 0.999999,
    fill: "#302322"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 27,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#302322"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#302322"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 31,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#302322"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 41,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#302322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Upcoming);
export default __webpack_public_path__ + "static/media/step1-upcoming.8fe09a64cc9f681a35a9aa841bed0a11.svg";
export { ForwardRef as ReactComponent };